import * as React from "react";

import Progress from "../../../common/organism/progress";
import { match as Match } from "react-router";
import { Contract } from "../../../../domain/model/contract";
import { Project } from "../../../../domain/model/project";
import { Customer } from "../../../../domain/model/customer";
import ClientContractCreateComponent from "./client_contract_create";
import ClientContractEditComponent from "./client_contract_edit";

interface IProps {
  isInit: boolean;
  isLoading: boolean;
  match: Match<{ companyId: string; projectId: string; customerId: string }>;
  contract: Contract | null;
  project: Project | null;
  customer: Customer | null;
  handleCreateSubmit: (values: any) => void;
  handleUpdateSubmit: (values: any) => void;
  handleApproveSubmit: (contract: Contract) => void;
}

const ClientContractComponent: React.FC<IProps> = (props) => {
  const {
    isInit,
    isLoading,
    match,
    contract,
    project,
    handleCreateSubmit,
    handleUpdateSubmit,
    handleApproveSubmit,
    customer,
  } = props;

  const path: string = match.path;

  // 初期化
  if (isInit) {
    return <Progress canAnimation={false} />;
  }

  let res: JSX.Element;

  switch (path) {
    // 新規作成用
    case "/client/contract/:companyId/:projectId/:customerId/_create": {
      res = (
        <ClientContractCreateComponent
          isInit={isInit}
          isLoading={isLoading}
          project={project}
          customer={customer}
          contract={contract}
          handleCreateSubmit={handleCreateSubmit}
        />
      );
      break;
    }
    // 編集用
    case "/client/contract/:companyId/:projectId/:customerId": {
      res = (
        <ClientContractEditComponent
          isInit={isInit}
          isLoading={isLoading}
          project={project}
          customer={customer}
          contract={contract}
          handleUpdateSubmit={handleUpdateSubmit}
          handleApprove={handleApproveSubmit}
        />
      );
      break;
    }

    default: {
      res = <div />;
    }
  }

  return res;
};

export default ClientContractComponent;



// WEBPACK FOOTER //
// ./src/presentation/component/client/contract/client_contract.tsx